import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import { CurrentLang, MagstimColor } from "common";

// Use normal CSS as the modal cannot be styled in the normal way
import "./MagstimModal.css";

class MagstimModal extends React.Component {

    constructor() {
        super();

        this.state = {
            isOpen: false,
            message: "",
            title: "",
            positiveButtonText:CurrentLang().message_box_OK,
            negativeButtonText:CurrentLang().message_box_cancel,
            callBack:undefined
        };
    }

    show = (title, message, positiveButtonText, negativeButtonText, callBack, icon, iconColour) => {

        if(positiveButtonText === undefined){
            positiveButtonText = CurrentLang().message_box_OK;
        }

        this.setState(
            {
                icon: icon ? icon : 'fas fa-exclamation-triangle',
                iconColour: iconColour ? iconColour : MagstimColor.MagstimRed,
                isOpen: true,
                message: message,
                title: title,
                positiveButtonText:positiveButtonText,
                negativeButtonText:negativeButtonText,
                callBack:callBack
            }
        )
    }

    getPositiveButtonText(){
        return this.state.positiveButtonText;
    }

    hide = () => {
        this.setState(
            {
                isOpen: false
            }
        )
    }

    setTitleAndMessage = (title, message) => {
        this.setState(
            {
                message: message,
                title: title
            }
        )
    }

    positiveButtonClick = () => {
        this.toggle();

        if(this.state.callBack !== undefined){
            this.state.callBack(this.state.positiveButtonText);
        }
    }

    negativeButtonClick = () => {
        this.toggle();

        if(this.state.callBack !== undefined){
            this.state.callBack(this.state.negativeButtonText);
        }
    }

    toggle = () => {
        this.setState(
            {
                isOpen: !this.state.isOpen
            }
        )
    }

    render() {

        var negativeButton;

        if(this.state.negativeButtonText !== undefined){
            negativeButton = <Button color="secondary" onClick={this.negativeButtonClick}>{this.state.negativeButtonText}</Button>
        }

        return (
            <div>
                <Modal isOpen={this.state.isOpen} toggle={this.toggle} contentClassName="magstim-modal">
                    <ModalHeader toggle={this.toggle} className="w-100">
                        <Row>
                            <Col sm="2">
                                <i className={"modal-icon fas " + this.state.icon + " fa-1x"} style={{color: this.state.iconColour }}></i>
                            </Col>
                            <Col>
                                <div className="modal-header-title col-centered">
                                {this.state.title}
                                </div>
                            </Col>
                        </Row>
                        
                    </ModalHeader>
                    <ModalBody>
                        {this.state.message}
                    </ModalBody>
                    <ModalFooter>
                        {negativeButton}
                        <Button color="primary" onClick={this.positiveButtonClick}>{this.state.positiveButtonText}</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default MagstimModal;